import React, { useState, useEffect } from "react";
import api from "../../../api/api";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

const VatCreate = () => {
  const [searchData, setSearchData] = useState([]);
  const [results, setResults] = useState([]);
  const { register, handleSubmit, unregister, setValue } = useForm();

  // useEffect(() => {
  //  console.log('results',results)
  // }, [results])

  // fetch company
  useEffect(() => {
    api
      .get(`services/company/`)
      .then((response) => {
        // console.log(response.data)
        setSearchData(
          response.data.map(({ company_name: name, id }) => ({ name, id }))
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item);
    api
      .get(`/services/company/?id=${item.id}`)
      .then((response) => {
        // console.log("Result",response.data)
        setResults(response.data[0]);
      })
      .catch((error) => {
        toast.error("something went wrong");
      });
  };

  const handleOnFocus = () => {
    // console.log('Focused')
  };

  /// handle submit
  const handleSub = (data) => {
    //  console.log('data',data)
    data.company = results.id;
    api
      .post("/services/vat-entry/", data)
      .then((response) => {
        toast.success("VAt registered successfully");
      })
      .catch((error) => {
        toast.error("something went wrong");
      });
  };

  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };

  return (
    <section className="px-3 md:px-10">
      <h1 className="text-primary-red mt-2 text-center  text-3xl font-bold lg:!mt-6">
        Create VAT Entry Report
      </h1>
      <p className="text-primary-red ">Vat Entry No. : 1</p>

      <div className=" grid grid-cols-3 border-2 text-sm my-3 border-primary-blue ">
        <div className=" flex gap-3 p-2 border-primary-blue md:border-r  ">
          <p className="text-primary-red">VAT Entry Months : </p>
          <input
            className=" border-primary-blue border px-1"
            type="text"
            name=""
            id=""
          />
        </div>
        <div className=" flex gap-3 p-2 border-primary-blue md:border-r  ">
          <p className="text-primary-red">VAT Entry Start Date : </p>
          <input
            className=" border-primary-blue border px-1"
            type="text"
            name=""
            id=""
          />
        </div>
        <div className=" flex gap-3 p-2   ">
          <p className="text-primary-red">VAT Entry End Date : </p>
          <input
            className=" border-primary-blue border px-1"
            type="text"
            name=""
            id=""
          />
        </div>
      </div>
      <table className="border-primary-blue min-w-full border my-5 text-center">
        <thead className="font-Bree bg-primary-red text-lg font-bold">
          <tr className="">
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              SN.
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Company Name
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Company Address
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              PAN / VAT No.
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Contact Person Name
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Contact No .
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Remarks
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>

        <tr className="">
            <td className=" text-primary-blue border border-primary-blue">1</td>
            <td className=" text-primary-blue border  border-primary-blue">
              ABC Company
            </td>
            <td className=" text-primary-blue border border-primary-blue">
              Bharatpur
            </td>
            <td className=" text-primary-blue border border-primary-blue">2</td>
            <td className=" text-primary-blue border border-primary-blue">
              Arjun
            </td>
            <td className=" text-primary-blue border border-primary-blue">
              Contact no.
            </td>
            <td className=" text-primary-blue border border-primary-blue">
              test Remarks
            </td>
            <td className="flex gap-2 justify-center items-center p-2 text-sm">
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                Process
              </button>
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                No Entery
              </button>
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                Complete
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="flex justify-end gap-4">

      <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white py-1">Save</button>
      <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white py-1">Submit</button>
      <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white py-1">Approve</button>
      </div>
    </section>
  );
};

export default VatCreate;
